import { Box, useMediaQuery } from "@mui/material";
import { colors } from "../theme/muiColors";
import Button from "@mui/material/Button";

export const ButtonsHoursOperation = ({ onSubmit = () => {}, type, disabled = false, setCancel, sx }) => {
  const isXs = useMediaQuery("(max-width:600px)");
  return (
    <Box key={"saveButton"} display={"flex"} justifyContent={"space-evenly"} justifyItems={"center"}>
      <Button
        type={type}
        disabled={disabled}
        sx={{
          width: isXs ? "100px " : "150px",
          bgcolor: colors.orange[500],
          textTransform: "none",
          fontWeight: 600,
          borderRadius: "8px",
          boxShadow: "none",
          "&:hover": { bgcolor: colors.orange[600], boxShadow: "none" },
        }}
        onClick={async () => {
          try {
            setCancel(true);
          } catch (error) {}
        }}
        variant="contained"
        disableElevation
      >
        Cancel
      </Button>

      <Button
        type={type}
        disabled={disabled}
        sx={{
          width: isXs ? "100px " : "150px",
          bgcolor: colors.orange[500],
          textTransform: "none",
          fontWeight: 600,
          borderRadius: "8px",
          boxShadow: "none",
          "&:hover": { bgcolor: colors.orange[600], boxShadow: "none" },
        }}
        onClick={async () => {
          try {
            await onSubmit();
          } catch (error) {
            console.error("Error when traying to execute: onSubmit();");
            console.error(error);
          }
        }}
        variant="contained"
        disableElevation
      >
        Save
      </Button>
    </Box>
  );
};
